/**
 * Option lists for the inventory filter row. Type / Status / Condition are static
 * enums (mirrors the legacy `item-list-config` filter definitions verbatim); the
 * Owner / Location / Supplier / Model dropdowns are populated at runtime from the
 * warehouse hooks (useOwners / useLocations / useSuppliers / useItemModels) and
 * so are assembled inside the filter-row component, not here.
 */

export interface FilterOption {
  value: string;
  label: string;
}

/** Sentinel used by the Select-based filters to represent "no constraint". */
export const ANY = '__any__';

export const TYPE_OPTIONS: FilterOption[] = [
  { value: 'equipment', label: 'Equipment' },
  { value: 'component', label: 'Component' },
];

export const STATUS_OPTIONS: FilterOption[] = [
  { value: 'available', label: 'Available' },
  { value: 'in_use', label: 'In Use' },
  { value: 'loaned', label: 'Loaned' },
  { value: 'installed', label: 'Installed' },
  { value: 'sold', label: 'Sold' },
  { value: 'damaged', label: 'Damaged' },
  { value: 'maintenance', label: 'Maintenance' },
];

export const CONDITION_OPTIONS: FilterOption[] = [
  { value: 'new', label: 'New' },
  { value: 'used', label: 'Used' },
  { value: 'refurbished', label: 'Refurbished' },
  { value: 'damaged', label: 'Damaged' },
];

/** All server-side filter keys the inventory list drives (for reset + params). */
export interface ItemFilters {
  item_type: string;
  status: string;
  condition: string;
  owner: string;
  location_id: string;
  supplier_id: string;
  model_id: string;
  rack_id: string;
}

export const EMPTY_FILTERS: ItemFilters = {
  item_type: ANY,
  status: ANY,
  condition: ANY,
  owner: ANY,
  location_id: ANY,
  supplier_id: ANY,
  model_id: ANY,
  rack_id: ANY,
};

/** Collapse the `__any__` sentinel to `undefined` so it drops from the query. */
export const filterValue = (v: string): string | undefined => (v === ANY ? undefined : v);
